import { render } from "./Agenti.vue?vue&type=template&id=fb9ed79a&scoped=true"
import script from "./Agenti.vue?vue&type=script&lang=js"
export * from "./Agenti.vue?vue&type=script&lang=js"

import "./Agenti.vue?vue&type=style&index=0&id=fb9ed79a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9ed79a"]])

export default __exports__